import { Box, Typography } from '@mui/material';
import { ReactNode, useState } from 'react';

import { FormVariants } from '@/containers';
import { Link } from '@/containers/Link';
import { backgroundV2, certificationLogo, lumiqWhiteLogo } from '@/images';

import { NASBADisclaimerModal } from './NASBADisclaimerModal';

const CertificationInfo = () => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Box
      sx={{
        mt: 8,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1.25,
        maxWidth: 300,
      }}>
      <Box component="img" src={certificationLogo} sx={{ width: 36 }} />
      <Typography variant="caption1" sx={{ color: 'white', lineHeight: 1.5 }}>
        Verifiable under{' '}
        <Link onClick={() => setOpen(true)} inline color="white">
          NASBA
        </Link>{' '}
        CPE Standards, Canadian CPD, and United Kingdom CPD
      </Typography>
      <NASBADisclaimerModal isOpen={open} onClose={() => setOpen(false)} />
    </Box>
  );
};

export const PageContainer = ({
  variant,
  children,
  hideCertificationInfo,
}: {
  children?: ReactNode;
  hideCertificationInfo?: boolean;
  variant?: (typeof FormVariants)[keyof typeof FormVariants];
}) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
        px: 2,
        py: 6,
        alignItems: 'center',
        justifyContent: 'center',
        background: `url(${backgroundV2}) center`,
        backgroundSize: 'cover',
      }}>
      {!hideCertificationInfo && (
        <Box
          component="img"
          src={lumiqWhiteLogo}
          sx={{ width: 200, mb: 6, display: { xs: 'flex', md: 'none' } }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 6,
          width: '100%',
        }}>
        {!hideCertificationInfo && (
          <Box
            sx={{
              display: {
                xs: 'none',
                md: 'flex',
              },
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Box component="img" src={lumiqWhiteLogo} sx={{ width: 200 }} />
            <Typography variant="h2" sx={{ color: 'white', width: 300, mt: 2 }}>
              {variant === FormVariants.FREE_TRIAL_CPD
                ? 'CPD podcasts worth listening to.'
                : variant === FormVariants.FREE_TRIAL_CPE
                  ? 'CPE podcasts worth listening to.'
                  : 'Exceptional podcasts for finance & accounting professionals.'}
            </Typography>
            {(variant === FormVariants.FREE_TRIAL_CPD ||
              variant === FormVariants.FREE_TRIAL_CPE) && (
              <Typography
                variant="h4"
                sx={{ color: 'white', width: 300, mt: 2 }}>
                Stories of fraud, leadership deep dives, technical know-how, and
                more. Start listening today.
              </Typography>
            )}
            <CertificationInfo />
          </Box>
        )}
        {children}
      </Box>
      <Box
        sx={{
          display: {
            xs: 'block',
            md: 'none',
          },
        }}>
        <CertificationInfo />
      </Box>
    </Box>
  );
};
